import type { AllRouteEndpoints } from "../routeTypes";

export const appsUserInfoUpdateClickThroughTrackingConfigCacheKeys: AllRouteEndpoints[] = [
  "/apps/user_info/get_click_through_tracking_config",
];
